import { render, staticRenderFns } from "./PostedBy.vue?vue&type=template&id=5d767985&"
import script from "./PostedBy.vue?vue&type=script&lang=js&"
export * from "./PostedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports